import { getBrowser } from '@lighthouse/tools'
import { useEffect } from 'react'
import type { Options } from 'react-hotkeys-hook'
import { useHotkeys } from 'react-hotkeys-hook'

import { useCurrentPageContext, useCurrentStackIdContext } from '@/contexts/PageContext'

import { pageUndoRedoController } from './controller'
import { usePageUndoRedoHelper } from './handler'

/**
 * 页面block及node操作的撤销重做
 *
 * @param {Options} options
 */
export const usePageUndoRedo = (options: Options, deps: React.DependencyList) => {
    const stackId = useCurrentStackIdContext()
    const { pageId } = useCurrentPageContext()

    useEffect(() => {
        return () => {
            pageUndoRedoController.clear()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps)

    const helper = usePageUndoRedoHelper({ pageId, stackId })

    useHotkeys(
        'ctrl+z, ⌘+z, ctrl+shift+z, ⌘+shift+z, ctrl+y, ⌘+y',
        (event, hotkeysEvent) => {
            const isMac = getBrowser().getBrowserInfo().platform === 'Macintosh'
            if (isMac) {
                switch (hotkeysEvent.key) {
                    case '⌘+z': {
                        event.preventDefault()
                        helper.undo()

                        break
                    }

                    case '⌘+shift+z':
                    case '⌘+y': {
                        event.preventDefault()
                        helper.redo()
                        break
                    }

                    default: {
                        break
                    }
                }
            } else {
                switch (hotkeysEvent.key) {
                    case 'ctrl+z': {
                        event.preventDefault()
                        helper.undo()

                        break
                    }

                    case 'ctrl+shift+z':
                    case 'ctrl+y': {
                        event.preventDefault()
                        helper.redo()
                        break
                    }

                    default: {
                        break
                    }
                }
            }
        },
        options
    )
}
